export const isContainerMd = () => {
    return window.innerWidth >= 768;
}